import { render, staticRenderFns } from "./password.forgot.vue?vue&type=template&id=fdbed908&scoped=true&"
import script from "./password.forgot.vue?vue&type=script&lang=js&"
export * from "./password.forgot.vue?vue&type=script&lang=js&"
import style0 from "./password.forgot.vue?vue&type=style&index=0&id=fdbed908&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdbed908",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\public\\Isaura\\id.es6.vn\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fdbed908')) {
      api.createRecord('fdbed908', component.options)
    } else {
      api.reload('fdbed908', component.options)
    }
    module.hot.accept("./password.forgot.vue?vue&type=template&id=fdbed908&scoped=true&", function () {
      api.rerender('fdbed908', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/password/password.forgot.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/views/password/password.forgot.vue
// module id = 707
// module chunks = 4